import moment from "moment";

import WordCount from "../../../components/shared/WordCount.jsx";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select";
import { Textarea } from "../../../components/ui/textarea";
import { cn, getCharCount } from "../../../lib/utils.js";

const LeadForm = ({ leadData, setLeadData }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="title">
            Lead Title <span className="text-red-500">*</span>
          </Label>
          <Input
            id="title"
            value={leadData.title}
            onChange={(e) => setLeadData({ ...leadData, title: e.target.value })}
            placeholder="e.g., Office Building Construction"
            required
          />
        </div>
        <div>
          <Label htmlFor="companyName">Company Name</Label>
          <Input
            id="companyName"
            value={leadData.companyName || ""}
            onChange={(e) => setLeadData({ ...leadData, companyName: e.target.value })}
            placeholder="Company name"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="contactPerson">Contact Person</Label>
          <Input
            id="contactPerson"
            value={leadData.contactPerson || ""}
            onChange={(e) => setLeadData({ ...leadData, contactPerson: e.target.value })}
            placeholder="Contact person name"
          />
        </div>
        <div>
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            value={leadData.phone || ""}
            onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
            placeholder="Phone number"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={leadData.email || ""}
            onChange={(e) => setLeadData({ ...leadData, email: e.target.value })}
            placeholder="Email address"
          />
        </div>
        <div>
          <Label htmlFor="estimatedValue">Estimated Value (₹)</Label>
          <Input
            id="estimatedValue"
            type="number"
            value={leadData.estimatedValue || ""}
            onChange={(e) =>
              setLeadData({
                ...leadData,
                estimatedValue: e.target.value
              })
            }
            placeholder="0"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="priority">Priority</Label>
          <Select
            value={leadData.priority?.toLowerCase()}
            onValueChange={(value) => setLeadData({ ...leadData, priority: value })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="low">Low</SelectItem>
              <SelectItem value="medium">Medium</SelectItem>
              <SelectItem value="high">High</SelectItem>
              <SelectItem value="urgent">Urgent</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="meetingDate">Meeting Date</Label>
          <Input
            id="meetingDate"
            type="datetime-local"
            value={leadData.meetingDate ? moment(leadData.meetingDate).format("YYYY-MM-DDTHH:mm") : ""}
            onChange={(e) => setLeadData({ ...leadData, meetingDate: e.target.value })}
          />
        </div>
      </div>
      <div>
        <Label htmlFor="nextAction">Next Action</Label>
        <Input
          id="nextAction"
          value={leadData.nextAction || ""}
          onChange={(e) => setLeadData({ ...leadData, nextAction: e.target.value })}
          placeholder="e.g., Schedule site visit"
        />
      </div>
      <div>
        <Label htmlFor="notes">Notes</Label>
        <Textarea
          id="notes"
          value={leadData.notes || ""}
          onChange={(e) => setLeadData({ ...leadData, notes: e.target.value })}
          className={cn(getCharCount(leadData.notes || "") > 500 && "border-red-500")}
          rows={3}
          placeholder="Additional notes about this lead"
        />
        <WordCount text={leadData.notes || ""} />
      </div>
    </div>
  );
};

export default LeadForm;
